// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__2TJKS","load8":"styles_load8__3tPXy"};